<template>
  <div class="videoManage">
    <!-- 顶部 Tab 栏 -->
    <div class="tabBar">
      <div
        v-for="(item,i) in video_list"
        :key="i"
        class="tabItem"
        :class="{'tabItem--active': i == video_s_index}"
        @click="bar_select_click(i)"
      >{{ item }}</div>
      <div class="tabInk" :style="{ left: inkLeft + 'px', width: inkWidth + 'px' }"></div>
      <!-- 帮助图标 -->
      <div class="helpIcon" @click="showHelp = true">?</div>
    </div>

    <!-- 帮助弹窗 -->
    <Popup :show="showHelp" round class="helpPopup">
      <div class="helpHeader" v-if="showHelp">
        <span>使用帮助</span>
        <div class="helpClose" @click="showHelp = false">×</div>
      </div>
      <div class="helpBody" v-if="showHelp">
        <div v-if="helpImages.length === 0" class="helpEmpty">暂无帮助图片</div>
        <div v-else class="helpImgList">
          <div class="helpImgItem" v-for="(img, i) in helpImages" :key="i">
            <p class="helpImgDesc" v-if="img.desc" v-html="img.desc"></p>
            <img v-if="img.src" :src="img.src" :alt="img.alt" @click="openPreview(i)" />
            <!-- <p class="helpImgName">{{ img.alt }}</p> -->
          </div>
        </div>
      </div>
    </Popup>

    <!-- 自定义图片预览弹窗（PC 友好） -->
    <Popup :show="previewShow" class="previewPopup" :overlay-style="{ background: 'rgba(0,0,0,0.92)' }">
      <div class="previewWrap">
        <div class="previewClose" @click="previewShow = false">×</div>
        <div class="previewArrow previewArrow--left" v-if="previewImages.length > 1" @click="previewPrev">‹</div>
        <div class="previewArrow previewArrow--right" v-if="previewImages.length > 1" @click="previewNext">›</div>
        <div class="previewDesc" v-if="previewDesc" v-html="previewDesc"></div>
        <img :src="previewSrc" class="previewImage" />
        <div class="previewIndicator" v-if="previewImages.length > 1">{{ previewIndex + 1 }} / {{ previewImages.length }}</div>
      </div>
    </Popup>

    <!-- 内容区 -->
    <div class="videoContainer">
      <component :is="currentComponent" :key="video_s_index" />
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, ref, nextTick } from "vue";
import { Popup } from 'vant'
import DoctorPage from '@/components/video/doctorPage.vue'
import Orderinfo from '@/components/video/orderinfo.vue'
import UesrManage from '@/components/video/uesrManage.vue'
import helpConfig from '@/config/helpConfig.js'

const video_list = ref(["医师管理", "订单查询", "业务员管理"]);
const video_s_index = ref(0)
const showHelp = ref(false)

// 自定义图片预览状态
const previewShow = ref(false)
const previewIndex = ref(0)
const previewImages = ref([])

const previewSrc = computed(() => {
  return previewImages.value[previewIndex.value] || ''
})
const previewDesc = computed(() => {
  const src = previewImages.value[previewIndex.value]
  if (!src) return ''
  const img = helpImages.value.find(item => item.src === src)
  return img ? img.desc : ''
})

const openPreview = (index) => {
  // 只收集有图片的项用于预览
  const withImages = helpImages.value.filter(img => img.src)
  const target = helpImages.value[index]
  const previewIndex = withImages.findIndex(img => img.alt === target.alt)
  if (previewIndex === -1) return
  previewImages.value = withImages.map(img => img.src)
  previewIndex.value = previewIndex
  previewShow.value = true
}
const previewPrev = () => {
  previewIndex.value = (previewIndex.value - 1 + previewImages.value.length) % previewImages.value.length
}
const previewNext = () => {
  previewIndex.value = (previewIndex.value + 1) % previewImages.value.length
}

// 使用 webpack require.context 动态加载 src/assets/imgs/help 下的图片
// 再与 helpConfig 合并，确保所有配置的步骤都显示（无图片的步骤只显示文案）
const helpImages = ref([])
try {
  const context = require.context('@/assets/imgs/help', false, /\.(jpg|jpeg|png|webp|gif|JPG|JPEG|PNG)$/)
  const imageMap = {}
  context.keys().forEach(key => {
    const filename = key.replace('./', '')
    const alt = filename.split('.')[0]
    imageMap[alt] = {
      src: context(key),
      alt,
      num: parseInt((filename.match(/\d+/) || ['0'])[0])
    }
  })
  // 以配置文件的步骤顺序为准，确保所有步骤都显示
  helpImages.value = Object.keys(helpConfig)
    .filter(key => /^\d+$/.test(key.replace('step-', '')))
    .sort((a, b) => {
      const na = parseInt(a.replace('step-', '')) || 0
      const nb = parseInt(b.replace('step-', '')) || 0
      return na - nb
    })
    .map(key => ({
      src: imageMap[key] ? imageMap[key].src : '',
      alt: key,
      desc: (helpConfig[key] && helpConfig[key].desc) || '',
      num: parseInt(key.replace('step-', '')) || 0
    }))
} catch (e) {
  helpImages.value = []
}

const currentComponent = computed(() => {
  const map = [DoctorPage, Orderinfo, UesrManage]
  return map[video_s_index.value] || null
})

const inkLeft = ref(0)
const inkWidth = ref(0)

const updateInk = () => {
  nextTick(() => {
    const el = document.querySelector('.tabItem--active')
    if (el) {
      inkLeft.value = el.offsetLeft
      inkWidth.value = el.offsetWidth
    }
  })
}

const bar_select_click = (i) => {
  video_s_index.value = i
  updateInk()
}

onMounted(() => {
  updateInk()
})
</script>

<style scoped>
/* ===== 容器 ===== */
.videoManage {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #f0f2f5;
}

/* ===== Tab 栏 ===== */
.tabBar {
  display: flex;
  position: relative;
  background: #fff;
  padding: 0 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
  flex-shrink: 0;
  position: relative;
}
.tabItem {
  flex: 1;
  text-align: center;
  padding: 14px 0;
  font-size: 15px;
  color: #888;
  cursor: pointer;
  transition: color 0.25s;
  user-select: none;
  position: relative;
  z-index: 1;
}
.tabItem:hover {
  color: #4f46e5;
}
.tabItem--active {
  color: #4f46e5;
  font-weight: 600;
}
.tabInk {
  position: absolute;
  bottom: 0;
  height: 2px;
  background: #4f46e5;
  border-radius: 1px;
  transition: left 0.3s cubic-bezier(0.4, 0, 0.2, 1), width 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ===== 帮助图标 ===== */
.helpIcon {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #e8e8e8;
  color: #666;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
  z-index: 10;
}
.helpIcon:hover {
  background: #4f46e5;
  color: #fff;
}

/* ===== 帮助弹窗内容（scoped 有效，因为内容在 template 内） ===== */
.helpPopup {
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.helpHeader {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  border-bottom: 1px solid #ebedf0;
  position: relative;
  flex-shrink: 0;
}
.helpClose {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  color: #999;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
}
.helpClose:hover {
  color: #666;
}
.helpBody {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}
.helpEmpty {
  text-align: center;
  color: #bbb;
  font-size: 14px;
  padding: 40px 0;
}
.helpImgList {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.helpImgItem {
  text-align: center;
}
.helpImgItem img {
  max-width: 100%;
  max-height: 200px;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s;
  object-fit: contain;
}
.helpImgItem img:hover {
  transform: scale(1.02);
}
.helpImgName {
  font-size: 12px;
  color: #999;
  margin-top: 6px;
}
.helpImgDesc {
  font-size: 13px;
  color: #333;
  line-height: 1.6;
  margin-bottom: 8px;
  padding: 0 4px;
  text-align: left;
  white-space: pre-wrap;
}

/* ===== 内容区 ===== */
.videoContainer {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* ===== 滚动条 ===== */
.videoContainer::-webkit-scrollbar {
  width: 5px;
}
.videoContainer::-webkit-scrollbar-track {
  background: transparent;
}
.videoContainer::-webkit-scrollbar-thumb {
  background: rgba(99,102,241,0.35);
  border-radius: 3px;
}
.videoContainer::-webkit-scrollbar-thumb:hover {
  background: rgba(99,102,241,0.6);
}
</style>

<!-- 非 scoped 样式，用于 teleport 到 body 的 Popup 覆层 -->
<style>
/* 帮助弹窗覆层 */
.helpPopup.van-popup {
  width: 90% !important;
  max-width: 500px !important;
  max-height: 80vh !important;
  display: flex !important;
  flex-direction: column !important;
  overflow: hidden !important;
  border-radius: 16px !important;
}

/* 图片预览覆层 */
.previewPopup.van-popup {
  background: transparent;
  width: 100vw;
  height: 100vh;
  max-width: 100vw;
  max-height: 100vh;
}
.previewWrap {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.previewClose {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255,255,255,0.18);
  color: #fff;
  font-size: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
  line-height: 1;
  font-weight: bold;
}
.previewClose:hover {
  background: rgba(255,255,255,0.35);
}
.previewArrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255,255,255,0.15);
  color: #fff;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background 0.2s;
  user-select: none;
  line-height: 1;
  font-weight: bold;
}
.previewArrow:hover {
  background: rgba(255,255,255,0.35);
}
.previewArrow--left {
  left: 16px;
}
.previewArrow--right {
  right: 16px;
}
.previewImage {
  max-width: 90vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 4px;
}
.previewIndicator {
  position: absolute;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(255,255,255,0.7);
  font-size: 14px;
  background: rgba(0,0,0,0.4);
  padding: 4px 14px;
  border-radius: 12px;
  user-select: none;
}
.previewDesc {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  color: #fff;
  font-size: 15px;
  line-height: 1.6;
  max-width: 80vw;
  text-align: center;
  background: rgba(0,0,0,0.55);
  padding: 8px 18px;
  border-radius: 8px;
  white-space: pre-wrap;
  z-index: 10;
}
</style>
